module.exports = __webpack_public_path__ + "img/1748d168bbe53a20b5d0a7ea1edbee1f.4c5d77fb.jpg";